<template>
  <div>
    <h2 class="title">Premier client</h2>
    <form @submit.prevent="next">
      <div class="field">
        <label class="label">Nom</label>
        <input v-model="form.name" class="input" type="text" required />
      </div>

      <div class="field">
        <label class="label">Email</label>
        <input v-model="form.email" class="input" type="email" />
      </div>

      <div class="field">
        <label class="label">Adresse</label>
        <input v-model="form.address1" class="input" type="text" />
      </div>

      <button class="button is-light" @click="$emit('prev')" type="button">
        Back
      </button>
      <button class="button is-primary" type="submit">Next</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        address1: '',
      },
    };
  },
  methods: {
    next() {
      // 🚀 Emit local data to parent wizard
      this.$emit('next', { firstClient: this.form });
    },
  },
};
</script>
